<template lang="pug">
  .flex.items-center
    .block.align-middle.self-center(v-if="!checked && reactWord" :class="{'mr-10': reactWord}")  {{reactWord}}
    .block.align-middle.self-center(v-if="checked || !reactWord" :class="{'mr-10': label}")  {{label}}
    input.tgl.tgl-light.hidden(:id="id" type="checkbox"  v-model="checkedValue"  :value="checked" )
    label.select-none.cursor-pointer.relative.outline-none.tgl-btn(:for="id")
    // @input.lazy="$emit('checked', $event.target.value)"
</template>

<script>
import Button from '@/components/Button.vue';

export default {
  name: 'ToggleSwitch',
  components: {
    Button,
  },
  props: {
    checked: { 
      type: Boolean, 
      required: false, 
      default: true 
    },
    reactWord:{
      type: String, 
      required: false, 
    },
    id:{
      type: String, 
      required: true, 
      default: 'isActive' ,
    },
    disabled:{
      type: Boolean, 
      required: false, 
      default: false, 
    },
    label:{
      type: String, 
      required: true, 
      default: 'isActive' ,
      // type: Array,
      // default(){
      //   return ['Active']
      // }
    },

  },
  data() {
    return {

    };
  },
  mounted(){
  },
  computed: {
    checkedValue: {
      get() {
        return this.checked;
      },
      set(val) {
        // console.log(val);
        this.$emit('update:checked', val);
      }
    }
  },
  methods: {


  },
  watch:{
  }
};
</script>

<style lang="scss" scoped>

.tgl{
  display: none;
  &,
  &:after,
  &:before,
	& *,
  & *:after,
  & *:before,
  & + .tgl-btn {
		box-sizing: border-box;
		&::selection {
			background: none;
		}
	}
  &:checked + .tgl-btn:after {
		left:70%;
	}
}

.tgl-light {
  + .tgl-btn {
		// background: #f0f0f0;
    background: #fff;
    border: #333 solid 1px;
		border-radius: 10px;
		padding: 4px;
		transition: all .4s ease;
		&:after {
			border-radius: 50%;
			transition: all .2s ease;
      background : #333;
      border: #333 solid 1px ;
		}
	}
	&:checked + .tgl-btn {
		background: #006ce1;
    border: transparent solid 1px;
    &:after,
    &:before {
      background : #fff;
      border: transparent solid 1px !important;
    }
	}
}

.tgl-btn{
  
  width: 44px;
	height: 20px;
  &:after,
  &:before {
    
    position: relative;
    display: block;
    // border: solid 1px red;
    content: "";
    width: 10px;
    height: 10px;
  }
  &:after {
    left: 0;
    
  }
  
  &:before {
    display: none;
  }
}




// .tgl {
// 	display: none;
  
// 	// add default box-sizing for this scope
// 	&,
//   &:after,
//   &:before,
// 	& *,
//   & *:after,
//   & *:before,
// 	& + .tgl-btn {
// 		box-sizing: border-box;
// 		&::selection {
// 			background: none;
// 		}
// 	}
  
// 	+ .tgl-btn {
// 		outline: 0;
// 		display: block;
// 		width: 4em;
// 		height: 2em;
// 		position: relative;
// 		cursor: pointer;
//     user-select: none;
// 		&:after,
//     &:before {
// 			position: relative;
// 			display: block;
// 			content: "";
// 			width: 50%;
// 			height: 100%;
// 		}
    
// 		&:after {
// 			left: 0;
// 		}
    
// 		&:before {
// 			display: none;
// 		}
// 	}
  
// 	&:checked + .tgl-btn:after {
// 		left: 50%;
// 	}
// }

// // themes
// .tgl-light {
// 	+ .tgl-btn {
// 		background: #f0f0f0;
// 		border-radius: 2em;
// 		padding: 2px;
// 		transition: all .4s ease;
// 		&:after {
// 			border-radius: 50%;
// 			background: #fff;
// 			transition: all .2s ease;
// 		}
// 	}
  
// 	&:checked + .tgl-btn {
// 		background: #9FD6AE;
// 	}
// }



</style>